import {ReactElement} from 'react';
import {startNewDay, isDateChanged} from 'core/LifeCycle';
import {useLastRecalcDateTimeStore} from 'store/LastRecalcDateTime';
import {useCoreState} from 'store/utils';
import {useMount} from 'ui/effects/useMount';
import {useSavedMoney} from 'ui/utils/core';
import {useStateDependentAdapters} from 'ui/adapters';
import {daysBetween, getTodayStartTime} from 'shared/utils/dateTime';

export function NewDayStarted({children}: any): ReactElement {
  const dateChanged = isDateChanged(useLastRecalcDateTimeStore());
  const savedMoney = useSavedMoney();
  const coreState = useCoreState();
  const callAdapters = useStateDependentAdapters();

  const daysLeft = daysBetween(coreState.budget.finishDate, getTodayStartTime());
  const showActionsSelector = dateChanged && savedMoney > 0 && daysLeft > 1;

  useMount(() => {
    if (dateChanged && (savedMoney <= 0 || daysLeft <= 1)) {
      const updatedState = startNewDay(coreState);
      callAdapters(updatedState);
    }
  });

  return children(showActionsSelector);
}
